import ENDPOINTS from '../../../constants/apiEndPoints';
import {
  ChecklistQueryParams,
  GroupedChecklistsResponse,
} from '../../../pages/checklist/checklist';
import {axiosInstance} from '../../axiosInstance';

export const handleCreateChecklistService = async (
  payload: Record<string, any>,
) => {
  const response = await axiosInstance.post(
    ENDPOINTS.GET_CREATE_CHECKLIST,
    payload,
  );
  return response?.data;
};

export const handleGetChecklistService = async (id: string) => {
  const response = await axiosInstance.get(
    ENDPOINTS.GET_UPDATE_DELETE_CHECKLIST(id),
  );
  return response?.data?.data;
};

export const handleGetAllChecklistService = async (
  params?: ChecklistQueryParams,
) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_CHECKLIST, {
    params,
  });
  return response?.data?.data;
};

export const handleGetGroupedChecklistsService = async (
  params: Omit<
    ChecklistQueryParams,
    'page' | 'limit' | 'groupByDepartment' | 'grouped'
  > & {
    clientId: string;
  },
): Promise<GroupedChecklistsResponse> => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_CHECKLIST, {
    params: {...params, grouped: true},
  });
  return response?.data?.data;
};

export const handleUpdateChecklistService = async ({
  id,
  payload,
}: Record<string, any>) => {
  const response = await axiosInstance.put(
    ENDPOINTS.GET_UPDATE_DELETE_CHECKLIST(id),
    payload,
  );
  return response?.data;
};
export const handleDeleteChecklistService = async (id: string) => {
  const response = await axiosInstance.delete(
    ENDPOINTS.GET_UPDATE_DELETE_CHECKLIST(id),
  );
  return response?.data;
};

export const handleCreateChecklistCommentService = async (
  id: string,
  payload: Record<string, any>,
) => {
  const response = await axiosInstance.post(
    ENDPOINTS.ADD_CHECKLIST_COMMENT(id),
    payload,
  );
  return response?.data;
};

export const handleGetChecklistByShiftIDService = async (params: {
  shiftIds: string[];
  clientId?: string;
  branchId?: string;
  department?: string | string[];
}) => {
  const response = await axiosInstance.get(
    ENDPOINTS.GET_CHECKLIST_BY_SHIFT_ID,
    {
      params,
    },
  );
  return response?.data?.data;
};

export const handleBulkImportChecklistService = async (
  payload: Record<string, any>,
) => {
  const response = await axiosInstance.post(
    ENDPOINTS.BULK_IMPORT_CHECKLIST,
    payload,
  );
  return response?.data;
};

export const handleBulkArchiveChecklistService = async (payload: {
  checklistIds: string[];
  status: 'inactive';
  locationId?: string;
  locationType?: 'client' | 'branch' | 'subBranch';
}) => {
  const response = await axiosInstance.patch(
    ENDPOINTS.BULK_ARCHIVE_CHECKLIST,
    payload,
  );
  return response?.data;
};
